/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Event_GroupInputs */

const en_new_event_group = /** @type {(inputs: New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Event Group`)
};

const fr_new_event_group = /** @type {(inputs: New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau groupe d’événements`)
};

const de_new_event_group = /** @type {(inputs: New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Veranstaltungsgruppe`)
};

const it_new_event_group = /** @type {(inputs: New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo gruppo di eventi`)
};

const ru_new_event_group = /** @type {(inputs: New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новая группа мероприятий`)
};

const es_new_event_group = /** @type {(inputs: New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo grupo de eventos`)
};

const zh_cn2_new_event_group = /** @type {(inputs: New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新活动组`)
};

const ja_new_event_group = /** @type {(inputs: New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントグループ`)
};

const hi_new_event_group = /** @type {(inputs: New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया इवेंट ग्रुप`)
};

const pt_pt2_new_event_group = /** @type {(inputs: New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo Grupo de Eventos`)
};

/**
* | output |
* | --- |
* | "New Event Group" |
*
* @param {New_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_event_group = /** @type {((inputs?: New_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_event_group(inputs)
	if (locale === "de") return de_new_event_group(inputs)
	if (locale === "it") return it_new_event_group(inputs)
	if (locale === "ru") return ru_new_event_group(inputs)
	if (locale === "es") return es_new_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_new_event_group(inputs)
	if (locale === "ja") return ja_new_event_group(inputs)
	if (locale === "hi") return hi_new_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_new_event_group(inputs)
	return en_new_event_group(inputs)
});